// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Formality from "../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Belt_Float from "../../../../../../../node_modules/rescript/lib/es6/belt_Float.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Row$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Switch$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/switch/Switch.bs.js";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as IncidentalChargesCmp from "./incidental-charges/IncidentalChargesCmp.bs.js";
import * as AdjustFareDataMachine from "../../../app/repo/AdjustFareDataMachine.bs.js";
import * as ViewIncidentalCharges from "./incidental-charges/ViewIncidentalCharges.bs.js";
import * as AdjustFareStateMachine from "../AdjustFareStateMachine.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as PrimitiveFormTypes$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/PrimitiveFormTypes.bs.js";
import * as FormDateTimeInputTs$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/FormDateTimeInputTs.bs.js";
import * as FormRadioGroupInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormRadioGroupInput.bs.js";
import * as RoundedPrimaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/RoundedPrimaryButton.bs.js";
import * as AdjustFareUpdatePayloadGenerator from "../../../app/api-model/payload-generator/AdjustFareUpdatePayloadGenerator.bs.js";

function validateWaitingTimeWrtStartEndDateTime(startDateTime, endDateTime, waitingTime) {
  var start = Belt_Option.getWithDefault(startDateTime, Timestamp$Catalyst.make(0.0));
  var end = Belt_Option.getWithDefault(endDateTime, Timestamp$Catalyst.make(0.0));
  var waiting = Belt_Float.fromString(Belt_Option.getWithDefault(waitingTime, "0.0")) * 60.0 * 1000.0;
  var result = Timestamp$Catalyst.toFloat(end) - Timestamp$Catalyst.toFloat(start) - waiting;
  return result >= 0.0;
}

var validators_endDateTime = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, _metadata) {
      var endDateTime = param.endDateTime;
      if (endDateTime === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Please enter actual trip end time"
              };
      }
      var end_time = Caml_option.valFromOption(endDateTime);
      if (Caml_obj.caml_greaterthan(end_time, Timestamp$Catalyst.now(undefined))) {
        return {
                TAG: /* Error */1,
                _0: "Trip end time cannot be future time"
              };
      } else if (param.startDateTime !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: Caml_option.some(end_time)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please enter trip end time first"
              };
      }
    })
};

var validators_startDateTime = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, metadata) {
      var startDateTime = param.startDateTime;
      if (startDateTime === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Please enter actual trip start time"
              };
      }
      var start_time = Caml_option.valFromOption(startDateTime);
      if (Caml_obj.caml_greaterthan(start_time, Timestamp$Catalyst.now(undefined))) {
        return {
                TAG: /* Error */1,
                _0: "Trip start time cannot be future time"
              };
      } else if (Caml_obj.caml_lessthan(start_time, metadata.trip_accepted_time)) {
        return {
                TAG: /* Error */1,
                _0: "Trip start time should be greater than trip accept time"
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: Caml_option.some(start_time)
              };
      }
    })
};

var validators_toll = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, _metadata) {
      var toll = param.toll;
      if (toll !== undefined) {
        return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                        TAG: /* Float */3,
                        _0: toll
                      }), (function (amount) {
                      if (amount < 0.0) {
                        return {
                                TAG: /* Error */1,
                                _0: "Toll amount cannot be in negative"
                              };
                      } else {
                        return {
                                TAG: /* Ok */0,
                                _0: Belt_Float.fromString(amount.toFixed(2))
                              };
                      }
                    }));
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please enter toll amount"
              };
      }
    })
};

var validators_restrictedTime = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, _metadata) {
      var restrictedTime = param.restrictedTime;
      if (restrictedTime !== undefined) {
        return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                        TAG: /* Float */3,
                        _0: restrictedTime
                      }), (function (timeInMins) {
                      if (timeInMins < 0.0) {
                        return {
                                TAG: /* Error */1,
                                _0: "Restricted time cannot be in negative"
                              };
                      } else {
                        return {
                                TAG: /* Ok */0,
                                _0: Belt_Float.fromString(timeInMins.toFixed(2))
                              };
                      }
                    }));
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please enter restricted time"
              };
      }
    })
};

var validators_waitingTime = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, _metadata) {
      var waitingTime = param.waitingTime;
      if (waitingTime !== undefined) {
        return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                        TAG: /* Float */3,
                        _0: waitingTime
                      }), (function (timeInMins) {
                      if (timeInMins < 0.0) {
                        return {
                                TAG: /* Error */1,
                                _0: "Waiting time cannot be in negative"
                              };
                      } else {
                        return {
                                TAG: /* Ok */0,
                                _0: Belt_Float.fromString(timeInMins.toFixed(2))
                              };
                      }
                    }));
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please enter waiting time"
              };
      }
    })
};

var validators_travelDistance = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, _metadata) {
      var travelDistance = param.travelDistance;
      if (travelDistance !== undefined) {
        return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                        TAG: /* Float */3,
                        _0: travelDistance
                      }), (function (distance) {
                      if (distance < 0.0) {
                        return {
                                TAG: /* Error */1,
                                _0: "Travel distance cannot be in negative"
                              };
                      } else {
                        return {
                                TAG: /* Ok */0,
                                _0: Belt_Float.fromString(distance.toFixed(3))
                              };
                      }
                    }));
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please enter travel distance"
              };
      }
    })
};

var validators_duration = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, _metadata) {
      var duration = param.duration;
      if (duration !== undefined) {
        return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                        TAG: /* Float */3,
                        _0: duration
                      }), (function (durationInMins) {
                      if (durationInMins < 0.0) {
                        return {
                                TAG: /* Error */1,
                                _0: "Trip duration cannot be in negative"
                              };
                      } else {
                        return {
                                TAG: /* Ok */0,
                                _0: Belt_Float.fromString(durationInMins.toFixed(2))
                              };
                      }
                    }));
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please enter trip duration"
              };
      }
    })
};

var validators = {
  endDateTime: validators_endDateTime,
  startDateTime: validators_startDateTime,
  toll: validators_toll,
  restrictedTime: validators_restrictedTime,
  waitingTime: validators_waitingTime,
  travelDistance: validators_travelDistance,
  hasWaypoint: undefined,
  duration: validators_duration,
  durationSelector: undefined
};

function initialFieldsStatuses(_input) {
  return {
          endDateTime: /* Pristine */0,
          startDateTime: /* Pristine */0,
          toll: /* Pristine */0,
          restrictedTime: /* Pristine */0,
          waitingTime: /* Pristine */0,
          travelDistance: /* Pristine */0,
          hasWaypoint: /* Pristine */0,
          duration: /* Pristine */0,
          durationSelector: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.endDateTime;
  var match_0 = match ? match._0 : Curry._2(validators.endDateTime.validate, input, metadata);
  var match$1 = fieldsStatuses.startDateTime;
  var match_0$1 = match$1 ? match$1._0 : Curry._2(validators.startDateTime.validate, input, metadata);
  var match$2 = fieldsStatuses.toll;
  var match_0$2 = match$2 ? match$2._0 : Curry._2(validators.toll.validate, input, metadata);
  var match$3 = fieldsStatuses.restrictedTime;
  var match_0$3 = match$3 ? match$3._0 : Curry._2(validators.restrictedTime.validate, input, metadata);
  var match$4 = fieldsStatuses.waitingTime;
  var match_0$4 = match$4 ? match$4._0 : Curry._2(validators.waitingTime.validate, input, metadata);
  var match$5 = fieldsStatuses.travelDistance;
  var match_0$5 = match$5 ? match$5._0 : Curry._2(validators.travelDistance.validate, input, metadata);
  var match_0$6 = {
    TAG: /* Ok */0,
    _0: input.hasWaypoint
  };
  var match$6 = fieldsStatuses.duration;
  var match_0$7 = match$6 ? match$6._0 : Curry._2(validators.duration.validate, input, metadata);
  var match_0$8 = {
    TAG: /* Ok */0,
    _0: input.durationSelector
  };
  var endDateTimeResult = match_0;
  var endDateTimeResult$1;
  if (endDateTimeResult.TAG === /* Ok */0) {
    var startDateTimeResult = match_0$1;
    if (startDateTimeResult.TAG === /* Ok */0) {
      var tollResult = match_0$2;
      if (tollResult.TAG === /* Ok */0) {
        var restrictedTimeResult = match_0$3;
        if (restrictedTimeResult.TAG === /* Ok */0) {
          var waitingTimeResult = match_0$4;
          if (waitingTimeResult.TAG === /* Ok */0) {
            var travelDistanceResult = match_0$5;
            if (travelDistanceResult.TAG === /* Ok */0) {
              var hasWaypointResult = match_0$6;
              if (hasWaypointResult.TAG === /* Ok */0) {
                var durationResult = match_0$7;
                if (durationResult.TAG === /* Ok */0) {
                  var durationSelectorResult = match_0$8;
                  if (durationSelectorResult.TAG === /* Ok */0) {
                    return {
                            TAG: /* Valid */0,
                            output: {
                              durationSelector: durationSelectorResult._0,
                              duration: durationResult._0,
                              hasWaypoint: hasWaypointResult._0,
                              travelDistance: travelDistanceResult._0,
                              waitingTime: waitingTimeResult._0,
                              restrictedTime: restrictedTimeResult._0,
                              toll: tollResult._0,
                              startDateTime: startDateTimeResult._0,
                              endDateTime: endDateTimeResult._0
                            },
                            fieldsStatuses: {
                              endDateTime: /* Dirty */{
                                _0: endDateTimeResult,
                                _1: /* Shown */0
                              },
                              startDateTime: /* Dirty */{
                                _0: startDateTimeResult,
                                _1: /* Shown */0
                              },
                              toll: /* Dirty */{
                                _0: tollResult,
                                _1: /* Shown */0
                              },
                              restrictedTime: /* Dirty */{
                                _0: restrictedTimeResult,
                                _1: /* Shown */0
                              },
                              waitingTime: /* Dirty */{
                                _0: waitingTimeResult,
                                _1: /* Shown */0
                              },
                              travelDistance: /* Dirty */{
                                _0: travelDistanceResult,
                                _1: /* Shown */0
                              },
                              hasWaypoint: /* Dirty */{
                                _0: hasWaypointResult,
                                _1: /* Hidden */1
                              },
                              duration: /* Dirty */{
                                _0: durationResult,
                                _1: /* Shown */0
                              },
                              durationSelector: /* Dirty */{
                                _0: durationSelectorResult,
                                _1: /* Hidden */1
                              }
                            },
                            collectionsStatuses: undefined
                          };
                  }
                  endDateTimeResult$1 = endDateTimeResult;
                } else {
                  endDateTimeResult$1 = endDateTimeResult;
                }
              } else {
                endDateTimeResult$1 = endDateTimeResult;
              }
            } else {
              endDateTimeResult$1 = endDateTimeResult;
            }
          } else {
            endDateTimeResult$1 = endDateTimeResult;
          }
        } else {
          endDateTimeResult$1 = endDateTimeResult;
        }
      } else {
        endDateTimeResult$1 = endDateTimeResult;
      }
    } else {
      endDateTimeResult$1 = endDateTimeResult;
    }
  } else {
    endDateTimeResult$1 = endDateTimeResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            endDateTime: /* Dirty */{
              _0: endDateTimeResult$1,
              _1: /* Shown */0
            },
            startDateTime: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            toll: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            restrictedTime: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            },
            waitingTime: /* Dirty */{
              _0: match_0$4,
              _1: /* Shown */0
            },
            travelDistance: /* Dirty */{
              _0: match_0$5,
              _1: /* Shown */0
            },
            hasWaypoint: /* Dirty */{
              _0: match_0$6,
              _1: /* Hidden */1
            },
            duration: /* Dirty */{
              _0: match_0$7,
              _1: /* Shown */0
            },
            durationSelector: /* Dirty */{
              _0: match_0$8,
              _1: /* Hidden */1
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurEndDateTimeField */0 :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.endDateTime, validators_endDateTime, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  endDateTime: status,
                                  startDateTime: init.startDateTime,
                                  toll: init.toll,
                                  restrictedTime: init.restrictedTime,
                                  waitingTime: init.waitingTime,
                                  travelDistance: init.travelDistance,
                                  hasWaypoint: init.hasWaypoint,
                                  duration: init.duration,
                                  durationSelector: init.durationSelector
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurStartDateTimeField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.startDateTime, validators_startDateTime, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  endDateTime: init.endDateTime,
                                  startDateTime: status,
                                  toll: init.toll,
                                  restrictedTime: init.restrictedTime,
                                  waitingTime: init.waitingTime,
                                  travelDistance: init.travelDistance,
                                  hasWaypoint: init.hasWaypoint,
                                  duration: init.duration,
                                  durationSelector: init.durationSelector
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTollField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.toll, validators_toll, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  endDateTime: init.endDateTime,
                                  startDateTime: init.startDateTime,
                                  toll: status,
                                  restrictedTime: init.restrictedTime,
                                  waitingTime: init.waitingTime,
                                  travelDistance: init.travelDistance,
                                  hasWaypoint: init.hasWaypoint,
                                  duration: init.duration,
                                  durationSelector: init.durationSelector
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurRestrictedTimeField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.restrictedTime, validators_restrictedTime, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  endDateTime: init.endDateTime,
                                  startDateTime: init.startDateTime,
                                  toll: init.toll,
                                  restrictedTime: status,
                                  waitingTime: init.waitingTime,
                                  travelDistance: init.travelDistance,
                                  hasWaypoint: init.hasWaypoint,
                                  duration: init.duration,
                                  durationSelector: init.durationSelector
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurWaitingTimeField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.waitingTime, validators_waitingTime, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  endDateTime: init.endDateTime,
                                  startDateTime: init.startDateTime,
                                  toll: init.toll,
                                  restrictedTime: init.restrictedTime,
                                  waitingTime: status,
                                  travelDistance: init.travelDistance,
                                  hasWaypoint: init.hasWaypoint,
                                  duration: init.duration,
                                  durationSelector: init.durationSelector
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTravelDistanceField */5 :
                  var result$5 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.travelDistance, validators_travelDistance, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  endDateTime: init.endDateTime,
                                  startDateTime: init.startDateTime,
                                  toll: init.toll,
                                  restrictedTime: init.restrictedTime,
                                  waitingTime: init.waitingTime,
                                  travelDistance: status,
                                  hasWaypoint: init.hasWaypoint,
                                  duration: init.duration,
                                  durationSelector: init.durationSelector
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurHasWaypointField */6 :
                  var result$6 = Formality.validateFieldOnBlurWithoutValidator(state.input.hasWaypoint, state.fieldsStatuses.hasWaypoint, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  endDateTime: init.endDateTime,
                                  startDateTime: init.startDateTime,
                                  toll: init.toll,
                                  restrictedTime: init.restrictedTime,
                                  waitingTime: init.waitingTime,
                                  travelDistance: init.travelDistance,
                                  hasWaypoint: status,
                                  duration: init.duration,
                                  durationSelector: init.durationSelector
                                };
                        }));
                  if (result$6 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$6,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDurationField */7 :
                  var result$7 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.duration, validators_duration, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  endDateTime: init.endDateTime,
                                  startDateTime: init.startDateTime,
                                  toll: init.toll,
                                  restrictedTime: init.restrictedTime,
                                  waitingTime: init.waitingTime,
                                  travelDistance: init.travelDistance,
                                  hasWaypoint: init.hasWaypoint,
                                  duration: status,
                                  durationSelector: init.durationSelector
                                };
                        }));
                  if (result$7 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$7,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDurationSelectorField */8 :
                  var result$8 = Formality.validateFieldOnBlurWithoutValidator(state.input.durationSelector, state.fieldsStatuses.durationSelector, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  endDateTime: init.endDateTime,
                                  startDateTime: init.startDateTime,
                                  toll: init.toll,
                                  restrictedTime: init.restrictedTime,
                                  waitingTime: init.waitingTime,
                                  travelDistance: init.travelDistance,
                                  hasWaypoint: init.hasWaypoint,
                                  duration: init.duration,
                                  durationSelector: status
                                };
                        }));
                  if (result$8 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$8,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */9 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */9,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */10,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */12);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */11);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */10 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */11 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */12 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateEndDateTimeField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  var nextFieldsStatuses = {
                    contents: state.fieldsStatuses
                  };
                  var result$9 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput, metadata, nextFieldsStatuses.contents.waitingTime, validators_waitingTime, (function (status) {
                          var init = nextFieldsStatuses.contents;
                          return {
                                  endDateTime: init.endDateTime,
                                  startDateTime: init.startDateTime,
                                  toll: init.toll,
                                  restrictedTime: init.restrictedTime,
                                  waitingTime: status,
                                  travelDistance: init.travelDistance,
                                  hasWaypoint: init.hasWaypoint,
                                  duration: init.duration,
                                  durationSelector: init.durationSelector
                                };
                        }));
                  if (result$9 !== undefined) {
                    nextFieldsStatuses.contents = result$9;
                  }
                  var result$10 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput, metadata, nextFieldsStatuses.contents.startDateTime, validators_startDateTime, (function (status) {
                          var init = nextFieldsStatuses.contents;
                          return {
                                  endDateTime: init.endDateTime,
                                  startDateTime: status,
                                  toll: init.toll,
                                  restrictedTime: init.restrictedTime,
                                  waitingTime: init.waitingTime,
                                  travelDistance: init.travelDistance,
                                  hasWaypoint: init.hasWaypoint,
                                  duration: init.duration,
                                  durationSelector: init.durationSelector
                                };
                        }));
                  if (result$10 !== undefined) {
                    nextFieldsStatuses.contents = result$10;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, nextFieldsStatuses.contents.endDateTime, state.submissionStatus, validators_endDateTime, (function (status) {
                                    var init = nextFieldsStatuses.contents;
                                    return {
                                            endDateTime: status,
                                            startDateTime: init.startDateTime,
                                            toll: init.toll,
                                            restrictedTime: init.restrictedTime,
                                            waitingTime: init.waitingTime,
                                            travelDistance: init.travelDistance,
                                            hasWaypoint: init.hasWaypoint,
                                            duration: init.duration,
                                            durationSelector: init.durationSelector
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateStartDateTimeField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$1 = {
                    contents: state.fieldsStatuses
                  };
                  var result$11 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$1, metadata, nextFieldsStatuses$1.contents.waitingTime, validators_waitingTime, (function (status) {
                          var init = nextFieldsStatuses$1.contents;
                          return {
                                  endDateTime: init.endDateTime,
                                  startDateTime: init.startDateTime,
                                  toll: init.toll,
                                  restrictedTime: init.restrictedTime,
                                  waitingTime: status,
                                  travelDistance: init.travelDistance,
                                  hasWaypoint: init.hasWaypoint,
                                  duration: init.duration,
                                  durationSelector: init.durationSelector
                                };
                        }));
                  if (result$11 !== undefined) {
                    nextFieldsStatuses$1.contents = result$11;
                  }
                  var result$12 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$1, metadata, nextFieldsStatuses$1.contents.endDateTime, validators_endDateTime, (function (status) {
                          var init = nextFieldsStatuses$1.contents;
                          return {
                                  endDateTime: status,
                                  startDateTime: init.startDateTime,
                                  toll: init.toll,
                                  restrictedTime: init.restrictedTime,
                                  waitingTime: init.waitingTime,
                                  travelDistance: init.travelDistance,
                                  hasWaypoint: init.hasWaypoint,
                                  duration: init.duration,
                                  durationSelector: init.durationSelector
                                };
                        }));
                  if (result$12 !== undefined) {
                    nextFieldsStatuses$1.contents = result$12;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, nextFieldsStatuses$1.contents.startDateTime, state.submissionStatus, validators_startDateTime, (function (status) {
                                    var init = nextFieldsStatuses$1.contents;
                                    return {
                                            endDateTime: init.endDateTime,
                                            startDateTime: status,
                                            toll: init.toll,
                                            restrictedTime: init.restrictedTime,
                                            waitingTime: init.waitingTime,
                                            travelDistance: init.travelDistance,
                                            hasWaypoint: init.hasWaypoint,
                                            duration: init.duration,
                                            durationSelector: init.durationSelector
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTollField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$2, metadata, state.fieldsStatuses.toll, state.submissionStatus, validators_toll, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            endDateTime: init.endDateTime,
                                            startDateTime: init.startDateTime,
                                            toll: status,
                                            restrictedTime: init.restrictedTime,
                                            waitingTime: init.waitingTime,
                                            travelDistance: init.travelDistance,
                                            hasWaypoint: init.hasWaypoint,
                                            duration: init.duration,
                                            durationSelector: init.durationSelector
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateRestrictedTimeField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$3, metadata, state.fieldsStatuses.restrictedTime, state.submissionStatus, validators_restrictedTime, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            endDateTime: init.endDateTime,
                                            startDateTime: init.startDateTime,
                                            toll: init.toll,
                                            restrictedTime: status,
                                            waitingTime: init.waitingTime,
                                            travelDistance: init.travelDistance,
                                            hasWaypoint: init.hasWaypoint,
                                            duration: init.duration,
                                            durationSelector: init.durationSelector
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateWaitingTimeField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$2 = {
                    contents: state.fieldsStatuses
                  };
                  var result$13 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$4, metadata, nextFieldsStatuses$2.contents.startDateTime, validators_startDateTime, (function (status) {
                          var init = nextFieldsStatuses$2.contents;
                          return {
                                  endDateTime: init.endDateTime,
                                  startDateTime: status,
                                  toll: init.toll,
                                  restrictedTime: init.restrictedTime,
                                  waitingTime: init.waitingTime,
                                  travelDistance: init.travelDistance,
                                  hasWaypoint: init.hasWaypoint,
                                  duration: init.duration,
                                  durationSelector: init.durationSelector
                                };
                        }));
                  if (result$13 !== undefined) {
                    nextFieldsStatuses$2.contents = result$13;
                  }
                  var result$14 = Formality.validateDependentFieldOnChangeWithMetadata(nextInput$4, metadata, nextFieldsStatuses$2.contents.endDateTime, validators_endDateTime, (function (status) {
                          var init = nextFieldsStatuses$2.contents;
                          return {
                                  endDateTime: status,
                                  startDateTime: init.startDateTime,
                                  toll: init.toll,
                                  restrictedTime: init.restrictedTime,
                                  waitingTime: init.waitingTime,
                                  travelDistance: init.travelDistance,
                                  hasWaypoint: init.hasWaypoint,
                                  duration: init.duration,
                                  durationSelector: init.durationSelector
                                };
                        }));
                  if (result$14 !== undefined) {
                    nextFieldsStatuses$2.contents = result$14;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$4, metadata, nextFieldsStatuses$2.contents.waitingTime, state.submissionStatus, validators_waitingTime, (function (status) {
                                    var init = nextFieldsStatuses$2.contents;
                                    return {
                                            endDateTime: init.endDateTime,
                                            startDateTime: init.startDateTime,
                                            toll: init.toll,
                                            restrictedTime: init.restrictedTime,
                                            waitingTime: status,
                                            travelDistance: init.travelDistance,
                                            hasWaypoint: init.hasWaypoint,
                                            duration: init.duration,
                                            durationSelector: init.durationSelector
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTravelDistanceField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$5, metadata, state.fieldsStatuses.travelDistance, state.submissionStatus, validators_travelDistance, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            endDateTime: init.endDateTime,
                                            startDateTime: init.startDateTime,
                                            toll: init.toll,
                                            restrictedTime: init.restrictedTime,
                                            waitingTime: init.waitingTime,
                                            travelDistance: status,
                                            hasWaypoint: init.hasWaypoint,
                                            duration: init.duration,
                                            durationSelector: init.durationSelector
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateHasWaypointField */6 :
                  var nextInput$6 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$6,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$6.hasWaypoint, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            endDateTime: init.endDateTime,
                                            startDateTime: init.startDateTime,
                                            toll: init.toll,
                                            restrictedTime: init.restrictedTime,
                                            waitingTime: init.waitingTime,
                                            travelDistance: init.travelDistance,
                                            hasWaypoint: status,
                                            duration: init.duration,
                                            durationSelector: init.durationSelector
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDurationField */7 :
                  var nextInput$7 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$7,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$7, metadata, state.fieldsStatuses.duration, state.submissionStatus, validators_duration, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            endDateTime: init.endDateTime,
                                            startDateTime: init.startDateTime,
                                            toll: init.toll,
                                            restrictedTime: init.restrictedTime,
                                            waitingTime: init.waitingTime,
                                            travelDistance: init.travelDistance,
                                            hasWaypoint: init.hasWaypoint,
                                            duration: status,
                                            durationSelector: init.durationSelector
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDurationSelectorField */8 :
                  var nextInput$8 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$8,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$8.durationSelector, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            endDateTime: init.endDateTime,
                                            startDateTime: init.startDateTime,
                                            toll: init.toll,
                                            restrictedTime: init.restrictedTime,
                                            waitingTime: init.waitingTime,
                                            travelDistance: init.travelDistance,
                                            hasWaypoint: init.hasWaypoint,
                                            duration: init.duration,
                                            durationSelector: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */9 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */10 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */11 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateEndDateTime: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateEndDateTimeField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateStartDateTime: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateStartDateTimeField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateToll: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTollField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateRestrictedTime: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateRestrictedTimeField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateWaitingTime: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateWaitingTimeField */4,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateTravelDistance: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTravelDistanceField */5,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateHasWaypoint: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateHasWaypointField */6,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateDuration: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateDurationField */7,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateDurationSelector: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateDurationSelectorField */8,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurEndDateTime: (function (param) {
              return Curry._1(dispatch, /* BlurEndDateTimeField */0);
            }),
          blurStartDateTime: (function (param) {
              return Curry._1(dispatch, /* BlurStartDateTimeField */1);
            }),
          blurToll: (function (param) {
              return Curry._1(dispatch, /* BlurTollField */2);
            }),
          blurRestrictedTime: (function (param) {
              return Curry._1(dispatch, /* BlurRestrictedTimeField */3);
            }),
          blurWaitingTime: (function (param) {
              return Curry._1(dispatch, /* BlurWaitingTimeField */4);
            }),
          blurTravelDistance: (function (param) {
              return Curry._1(dispatch, /* BlurTravelDistanceField */5);
            }),
          blurHasWaypoint: (function (param) {
              return Curry._1(dispatch, /* BlurHasWaypointField */6);
            }),
          blurDuration: (function (param) {
              return Curry._1(dispatch, /* BlurDurationField */7);
            }),
          blurDurationSelector: (function (param) {
              return Curry._1(dispatch, /* BlurDurationSelectorField */8);
            }),
          endDateTimeResult: Formality.exposeFieldResult(state.fieldsStatuses.endDateTime),
          startDateTimeResult: Formality.exposeFieldResult(state.fieldsStatuses.startDateTime),
          tollResult: Formality.exposeFieldResult(state.fieldsStatuses.toll),
          restrictedTimeResult: Formality.exposeFieldResult(state.fieldsStatuses.restrictedTime),
          waitingTimeResult: Formality.exposeFieldResult(state.fieldsStatuses.waitingTime),
          travelDistanceResult: Formality.exposeFieldResult(state.fieldsStatuses.travelDistance),
          hasWaypointResult: Formality.exposeFieldResult(state.fieldsStatuses.hasWaypoint),
          durationResult: Formality.exposeFieldResult(state.fieldsStatuses.duration),
          durationSelectorResult: Formality.exposeFieldResult(state.fieldsStatuses.durationSelector),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.endDateTime || match.startDateTime || match.toll || match.restrictedTime || match.waitingTime || match.travelDistance || match.hasWaypoint || match.duration || match.durationSelector) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */9);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */10);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */11);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */11,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */12);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getInitialFormState(new_order_fare, form_duration_selector) {
  return {
          durationSelector: AdjustFareStateMachine.DurationSelector.toString(form_duration_selector),
          duration: new_order_fare.data.order_fare.travel_duration.toFixed(2),
          hasWaypoint: new_order_fare.data.has_waypoints,
          travelDistance: new_order_fare.data.order_fare.travel_distance.toFixed(3),
          waitingTime: new_order_fare.data.order_fare.waiting_time.toFixed(2),
          restrictedTime: new_order_fare.data.order_fare.total_restricted_time_mins.toFixed(2),
          toll: Currency.fromCurrency(new_order_fare.data.order_fare.toll).toFixed(2),
          startDateTime: Caml_option.some(new_order_fare.data.start_time),
          endDateTime: Caml_option.some(new_order_fare.data.end_time)
        };
}

function updateNewFareDetails(new_fare_details, preview_fare_response) {
  return {
          data: {
            crn: new_fare_details.data.crn,
            trip_accepted_time: new_fare_details.data.trip_accepted_time,
            start_time: new_fare_details.data.start_time,
            pickup_time: new_fare_details.data.pickup_time,
            end_time: new_fare_details.data.end_time,
            order_type: new_fare_details.data.order_type,
            has_fixed_strategy: new_fare_details.data.has_fixed_strategy,
            has_waypoints: new_fare_details.data.has_waypoints,
            is_return_trip: new_fare_details.data.is_return_trip,
            order_fare: preview_fare_response.data.order_fare
          }
        };
}

function fetchPreviewNewFare(new_fare_details, form_duration_selector, dispatch, country) {
  var payload = AdjustFareUpdatePayloadGenerator.execute(new_fare_details, form_duration_selector);
  Curry._1(dispatch, {
        TAG: /* UpdateNewFareDetails */2,
        new_fare_datails: {
          TAG: /* Loading */0,
          _0: new_fare_details
        }
      });
  return AdjustFareDataMachine.previewFareChanges(payload, (function (preview_fare_response) {
                Curry._1(dispatch, {
                      TAG: /* UpdateNewFareDetails */2,
                      new_fare_datails: {
                        TAG: /* Live */1,
                        _0: updateNewFareDetails(new_fare_details, preview_fare_response)
                      }
                    });
                Curry._1(dispatch, {
                      TAG: /* UpdateSubmitButtonStatus */5,
                      is_submit_button_enabled: true
                    });
                var message = preview_fare_response.data.popup_message;
                if (message !== undefined) {
                  if (message.includes("Warning:")) {
                    return Curry._1(dispatch, {
                                TAG: /* OpenSnackbar */3,
                                snackbar_message: {
                                  TAG: /* Error */1,
                                  _0: message
                                }
                              });
                  } else {
                    return Curry._1(dispatch, {
                                TAG: /* OpenSnackbar */3,
                                snackbar_message: {
                                  TAG: /* Success */0,
                                  _0: message
                                }
                              });
                  }
                }
                
              }), (function (error) {
                Curry._1(dispatch, {
                      TAG: /* UpdateNewFareDetails */2,
                      new_fare_datails: {
                        TAG: /* Live */1,
                        _0: new_fare_details
                      }
                    });
                return Curry._1(dispatch, {
                            TAG: /* OpenSnackbar */3,
                            snackbar_message: {
                              TAG: /* Error */1,
                              _0: ErrorUtils$Catalyst.resolveError(error)
                            }
                          });
              }), country);
}

function updatedNewFareAfterFormChange(incidental_charges, new_fare_details, form_duration_selector, output, dispatch, country) {
  var newrecord = Caml_obj.caml_obj_dup(new_fare_details.data.order_fare);
  var updated_new_fare_details = {
    data: {
      crn: new_fare_details.data.crn,
      trip_accepted_time: new_fare_details.data.trip_accepted_time,
      start_time: output.startDateTime,
      pickup_time: new_fare_details.data.pickup_time,
      end_time: output.endDateTime,
      order_type: new_fare_details.data.order_type,
      has_fixed_strategy: new_fare_details.data.has_fixed_strategy,
      has_waypoints: Belt_Option.getWithDefault(output.hasWaypoint, false),
      is_return_trip: new_fare_details.data.is_return_trip,
      order_fare: (newrecord.incidental_charges = incidental_charges, newrecord.toll = Currency.toCurrency(output.toll), newrecord.total_restricted_time_mins = output.restrictedTime, newrecord.waiting_time = output.waitingTime, newrecord.travel_distance = output.travelDistance, newrecord.travel_duration = output.duration, newrecord)
    }
  };
  Curry._1(dispatch, {
        TAG: /* UpdateNewFareDetails */2,
        new_fare_datails: {
          TAG: /* Live */1,
          _0: updated_new_fare_details
        }
      });
  return fetchPreviewNewFare(updated_new_fare_details, form_duration_selector, dispatch, country);
}

function AdjustFareForm(Props) {
  var currency_symbol = Props.currency_symbol;
  var new_fare_details = Props.new_fare_details;
  var state = Props.state;
  var dispatch = Props.dispatch;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        return new_fare_details.data.order_fare.incidental_charges;
      });
  var updateIncidentalCharges = match$1[1];
  var incidental_charges = match$1[0];
  var adjustFareForm = useForm(getInitialFormState(new_fare_details, state.form_duration_selector), {
        trip_accepted_time: new_fare_details.data.trip_accepted_time,
        pickup_time: new_fare_details.data.pickup_time
      }, (function (output, _form) {
          return updatedNewFareAfterFormChange(incidental_charges, new_fare_details, state.form_duration_selector, output, dispatch, country);
        }));
  React.useEffect((function () {
          var match = state.reset_form;
          if (match) {
            Curry._1(adjustFareForm.reset, undefined);
            Curry._1(updateIncidentalCharges, (function (param) {
                    return new_fare_details.data.order_fare.incidental_charges;
                  }));
            Curry._1(dispatch, {
                  TAG: /* ResetChanges */7,
                  reset_form: false
                });
          }
          
        }), [state.reset_form]);
  var tmp;
  if (new_fare_details.data.has_fixed_strategy) {
    var value = adjustFareForm.input.duration;
    tmp = React.createElement(React.Fragment, undefined, React.createElement(Row$Catalyst.make, {
              children: React.createElement("div", undefined, React.createElement(FormRadioGroupInput$Catalyst.make, {
                        input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                return Curry._2(adjustFareForm.updateDurationSelector, (function (input, value) {
                                              Curry._1(dispatch, {
                                                    TAG: /* UpdateFormDurationSelector */0,
                                                    form_duration_selector: AdjustFareStateMachine.DurationSelector.toType(value)
                                                  });
                                              return {
                                                      durationSelector: value,
                                                      duration: input.duration,
                                                      hasWaypoint: input.hasWaypoint,
                                                      travelDistance: input.travelDistance,
                                                      waitingTime: input.waitingTime,
                                                      restrictedTime: input.restrictedTime,
                                                      toll: input.toll,
                                                      startDateTime: input.startDateTime,
                                                      endDateTime: input.endDateTime
                                                    };
                                            }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                              }), undefined, undefined, undefined, undefined, undefined, undefined, adjustFareForm.durationSelectorResult, undefined, "adjust-fare-duration-radio-button-group", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                        radio_props: {
                          options: {
                            hd: {
                              label: "Duration (MINS)",
                              value: "Mins"
                            },
                            tl: {
                              hd: {
                                label: "Start and End Date and Time",
                                value: "DateTime"
                              },
                              tl: /* [] */0
                            }
                          },
                          value: AdjustFareStateMachine.DurationSelector.toString(state.form_duration_selector),
                          row_layout: true
                        }
                      }))
            }), React.createElement(Row$Catalyst.make, {
              children: React.createElement("div", undefined, React.createElement("label", undefined, "Travel Duration (MINS)"), React.createElement(FormTextInput$Catalyst.make, {
                        input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                Curry._1(dispatch, {
                                      TAG: /* UpdatePreviewButtonStatus */6,
                                      is_preview_fare_button_enabled: true
                                    });
                                return Curry._2(adjustFareForm.updateDuration, (function (input, value) {
                                              return {
                                                      durationSelector: input.durationSelector,
                                                      duration: value,
                                                      hasWaypoint: input.hasWaypoint,
                                                      travelDistance: input.travelDistance,
                                                      waitingTime: input.waitingTime,
                                                      restrictedTime: input.restrictedTime,
                                                      toll: input.toll,
                                                      startDateTime: input.startDateTime,
                                                      endDateTime: input.endDateTime
                                                    };
                                            }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                              }), state.form_duration_selector === /* DateTime */1, undefined, "", undefined, undefined, undefined, adjustFareForm.durationResult, undefined, "", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                        textinput_props: {
                          value: value !== undefined ? value : ""
                        }
                      }))
            }));
  } else {
    tmp = null;
  }
  var value$1 = adjustFareForm.input.travelDistance;
  var value$2 = adjustFareForm.input.waitingTime;
  var value$3 = adjustFareForm.input.restrictedTime;
  var value$4 = adjustFareForm.input.toll;
  return React.createElement("div", undefined, React.createElement("div", {
                  className: "adjust-fare-form-wrapper"
                }, React.createElement("form", {
                      className: "adjust-fare-form"
                    }, tmp, React.createElement(Row$Catalyst.make, {
                          children: React.createElement("div", undefined, React.createElement("label", undefined, "Start Date Time"), React.createElement(FormDateTimeInputTs$Catalyst.make, {
                                    input_props: FormInput$Catalyst.make_props("", (function (param) {
                                            
                                          }), undefined, undefined, undefined, undefined, undefined, undefined, adjustFareForm.startDateTimeResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                    date_props: {
                                      value: adjustFareForm.input.startDateTime,
                                      minDate: undefined,
                                      maxDate: undefined,
                                      onChange: (function (date) {
                                          Curry._1(dispatch, {
                                                TAG: /* UpdatePreviewButtonStatus */6,
                                                is_preview_fare_button_enabled: true
                                              });
                                          return Curry._2(adjustFareForm.updateStartDateTime, (function (input, value) {
                                                        return {
                                                                durationSelector: input.durationSelector,
                                                                duration: input.duration,
                                                                hasWaypoint: input.hasWaypoint,
                                                                travelDistance: input.travelDistance,
                                                                waitingTime: input.waitingTime,
                                                                restrictedTime: input.restrictedTime,
                                                                toll: input.toll,
                                                                startDateTime: value,
                                                                endDateTime: input.endDateTime
                                                              };
                                                      }), Caml_option.some(date));
                                        }),
                                      format: "DD/MM/YYYY h:mm A",
                                      isDisabled: state.form_duration_selector === /* Mins */0,
                                      onClear: (function (param) {
                                          return Curry._2(adjustFareForm.updateStartDateTime, (function (input, _value) {
                                                        return {
                                                                durationSelector: input.durationSelector,
                                                                duration: input.duration,
                                                                hasWaypoint: input.hasWaypoint,
                                                                travelDistance: input.travelDistance,
                                                                waitingTime: input.waitingTime,
                                                                restrictedTime: input.restrictedTime,
                                                                toll: input.toll,
                                                                startDateTime: undefined,
                                                                endDateTime: input.endDateTime
                                                              };
                                                      }), undefined);
                                        })
                                    }
                                  }))
                        }), React.createElement(Row$Catalyst.make, {
                          children: React.createElement("div", undefined, React.createElement("label", undefined, "End Date Time"), React.createElement(FormDateTimeInputTs$Catalyst.make, {
                                    input_props: FormInput$Catalyst.make_props("", (function (param) {
                                            
                                          }), undefined, undefined, undefined, undefined, undefined, undefined, adjustFareForm.endDateTimeResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                    date_props: {
                                      value: adjustFareForm.input.endDateTime,
                                      minDate: undefined,
                                      maxDate: undefined,
                                      onChange: (function (date) {
                                          Curry._1(dispatch, {
                                                TAG: /* UpdatePreviewButtonStatus */6,
                                                is_preview_fare_button_enabled: true
                                              });
                                          return Curry._2(adjustFareForm.updateEndDateTime, (function (input, value) {
                                                        return {
                                                                durationSelector: input.durationSelector,
                                                                duration: input.duration,
                                                                hasWaypoint: input.hasWaypoint,
                                                                travelDistance: input.travelDistance,
                                                                waitingTime: input.waitingTime,
                                                                restrictedTime: input.restrictedTime,
                                                                toll: input.toll,
                                                                startDateTime: input.startDateTime,
                                                                endDateTime: value
                                                              };
                                                      }), Caml_option.some(date));
                                        }),
                                      format: "DD/MM/YYYY h:mm A",
                                      isDisabled: state.form_duration_selector === /* Mins */0,
                                      onClear: (function (param) {
                                          return Curry._2(adjustFareForm.updateEndDateTime, (function (input, _value) {
                                                        return {
                                                                durationSelector: input.durationSelector,
                                                                duration: input.duration,
                                                                hasWaypoint: input.hasWaypoint,
                                                                travelDistance: input.travelDistance,
                                                                waitingTime: input.waitingTime,
                                                                restrictedTime: input.restrictedTime,
                                                                toll: input.toll,
                                                                startDateTime: input.startDateTime,
                                                                endDateTime: undefined
                                                              };
                                                      }), undefined);
                                        })
                                    }
                                  }))
                        }), React.createElement(Row$Catalyst.make, {
                          children: React.createElement("div", undefined, React.createElement("label", undefined, "Trip has Waypoint"), React.createElement(Switch$Catalyst.make, {
                                    checked: Belt_Option.getWithDefault(adjustFareForm.input.hasWaypoint, false),
                                    on_change: (function (_event) {
                                        Curry._1(dispatch, {
                                              TAG: /* UpdatePreviewButtonStatus */6,
                                              is_preview_fare_button_enabled: true
                                            });
                                        var currentState = Belt_Option.getWithDefault(adjustFareForm.input.hasWaypoint, false);
                                        return Curry._2(adjustFareForm.updateHasWaypoint, (function (input, _value) {
                                                      return {
                                                              durationSelector: input.durationSelector,
                                                              duration: input.duration,
                                                              hasWaypoint: !currentState,
                                                              travelDistance: input.travelDistance,
                                                              waitingTime: input.waitingTime,
                                                              restrictedTime: input.restrictedTime,
                                                              toll: input.toll,
                                                              startDateTime: input.startDateTime,
                                                              endDateTime: input.endDateTime
                                                            };
                                                    }), !currentState);
                                      }),
                                    switch_color: /* Primary */1
                                  }))
                        }), React.createElement(Row$Catalyst.make, {
                          children: React.createElement("div", undefined, React.createElement("label", undefined, "Travel Distance (KMS)"), React.createElement(FormTextInput$Catalyst.make, {
                                    input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                            Curry._1(dispatch, {
                                                  TAG: /* UpdatePreviewButtonStatus */6,
                                                  is_preview_fare_button_enabled: true
                                                });
                                            return Curry._2(adjustFareForm.updateTravelDistance, (function (input, value) {
                                                          return {
                                                                  durationSelector: input.durationSelector,
                                                                  duration: input.duration,
                                                                  hasWaypoint: input.hasWaypoint,
                                                                  travelDistance: value,
                                                                  waitingTime: input.waitingTime,
                                                                  restrictedTime: input.restrictedTime,
                                                                  toll: input.toll,
                                                                  startDateTime: input.startDateTime,
                                                                  endDateTime: input.endDateTime
                                                                };
                                                        }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                          }), undefined, undefined, "", undefined, undefined, undefined, adjustFareForm.travelDistanceResult, undefined, "", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                    textinput_props: {
                                      value: value$1 !== undefined ? value$1 : ""
                                    }
                                  }))
                        }), React.createElement(Row$Catalyst.make, {
                          children: React.createElement("div", undefined, React.createElement("label", undefined, "Waiting Time (MINS)"), React.createElement(FormTextInput$Catalyst.make, {
                                    input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                            Curry._1(dispatch, {
                                                  TAG: /* UpdatePreviewButtonStatus */6,
                                                  is_preview_fare_button_enabled: true
                                                });
                                            return Curry._2(adjustFareForm.updateWaitingTime, (function (input, value) {
                                                          return {
                                                                  durationSelector: input.durationSelector,
                                                                  duration: input.duration,
                                                                  hasWaypoint: input.hasWaypoint,
                                                                  travelDistance: input.travelDistance,
                                                                  waitingTime: value,
                                                                  restrictedTime: input.restrictedTime,
                                                                  toll: input.toll,
                                                                  startDateTime: input.startDateTime,
                                                                  endDateTime: input.endDateTime
                                                                };
                                                        }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                          }), undefined, undefined, "", undefined, undefined, undefined, adjustFareForm.waitingTimeResult, undefined, "", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                    textinput_props: {
                                      value: value$2 !== undefined ? value$2 : ""
                                    }
                                  }))
                        }), React.createElement(Row$Catalyst.make, {
                          children: React.createElement("div", undefined, React.createElement("label", undefined, "Restricted Time (MINS)"), React.createElement(FormTextInput$Catalyst.make, {
                                    input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                            Curry._1(dispatch, {
                                                  TAG: /* UpdatePreviewButtonStatus */6,
                                                  is_preview_fare_button_enabled: true
                                                });
                                            return Curry._2(adjustFareForm.updateRestrictedTime, (function (input, value) {
                                                          return {
                                                                  durationSelector: input.durationSelector,
                                                                  duration: input.duration,
                                                                  hasWaypoint: input.hasWaypoint,
                                                                  travelDistance: input.travelDistance,
                                                                  waitingTime: input.waitingTime,
                                                                  restrictedTime: value,
                                                                  toll: input.toll,
                                                                  startDateTime: input.startDateTime,
                                                                  endDateTime: input.endDateTime
                                                                };
                                                        }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                          }), undefined, undefined, "", undefined, undefined, undefined, adjustFareForm.restrictedTimeResult, undefined, "", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                    textinput_props: {
                                      value: value$3 !== undefined ? value$3 : ""
                                    }
                                  }))
                        }), React.createElement(Row$Catalyst.make, {
                          children: React.createElement("div", undefined, React.createElement("label", undefined, "Toll (" + currency_symbol + ")"), React.createElement(FormTextInput$Catalyst.make, {
                                    input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                            Curry._1(dispatch, {
                                                  TAG: /* UpdatePreviewButtonStatus */6,
                                                  is_preview_fare_button_enabled: true
                                                });
                                            return Curry._2(adjustFareForm.updateToll, (function (input, value) {
                                                          return {
                                                                  durationSelector: input.durationSelector,
                                                                  duration: input.duration,
                                                                  hasWaypoint: input.hasWaypoint,
                                                                  travelDistance: input.travelDistance,
                                                                  waitingTime: input.waitingTime,
                                                                  restrictedTime: input.restrictedTime,
                                                                  toll: value,
                                                                  startDateTime: input.startDateTime,
                                                                  endDateTime: input.endDateTime
                                                                };
                                                        }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                          }), undefined, undefined, "", undefined, undefined, undefined, adjustFareForm.tollResult, undefined, "", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                    textinput_props: {
                                      value: value$4 !== undefined ? value$4 : ""
                                    }
                                  }))
                        }), React.createElement("div", {
                          className: "incidental-charge-container"
                        }, React.createElement(Row$Catalyst.make, {
                              children: React.createElement(ViewIncidentalCharges.make, {
                                    currency_symbol: currency_symbol,
                                    incidental_charges: incidental_charges,
                                    dispatch: dispatch,
                                    updateIncidentalCharges: updateIncidentalCharges
                                  })
                            }), React.createElement(Row$Catalyst.make, {
                              children: React.createElement(IncidentalChargesCmp.make, {
                                    currency_symbol: currency_symbol,
                                    incidental_charges: incidental_charges,
                                    updateIncidentalCharges: updateIncidentalCharges,
                                    state: state,
                                    dispatch: dispatch
                                  })
                            })))), React.createElement("div", {
                  className: "c-adjust-fare-form-action"
                }, React.createElement("div", {
                      className: "adjust-fare-preview-button-wrapper"
                    }, React.createElement(RoundedPrimaryButton$Catalyst.make, {
                          buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                TAG: /* Custom */1,
                                _0: (function (param) {
                                    return React.createElement("p", {
                                                className: state.is_preview_fare_button_enabled ? "adjust-fare-enabled-button-preview-text" : "adjust-fare-disabled-button-preview-text"
                                              }, "Preview New Fare Details");
                                  })
                              }, !state.is_preview_fare_button_enabled, (function (param) {
                                  return Curry._1(adjustFareForm.submit, undefined);
                                }), undefined, undefined, undefined, undefined, state.is_preview_fare_button_enabled ? "adjust-fare-preview-button-enabled" : "adjust-fare-preview-button-disabled", undefined, undefined)
                        }))));
}

var make = AdjustFareForm;

export {
  validateWaitingTimeWrtStartEndDateTime ,
  Form ,
  getInitialFormState ,
  updateNewFareDetails ,
  fetchPreviewNewFare ,
  updatedNewFareAfterFormChange ,
  make ,
  
}
/* react Not a pure module */
